import gql from 'graphql-tag';

export const CALENDAR_VIEW_CONFIGURATION = gql`
  query CalendarViewableUsers {
    dealActivity {
      result: calendarViewConfiguration {
        error
        success
        list {
          id
          name
          color
          isActive
          owner {
            id
            fullName
          }
        }
      }
    }
  }
`;
